var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcArrowLeft2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3061_4801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0383 6.87692C14.9728 6.86629 14.9066 6.86139 14.8403 6.86225H3.55262L3.79875 6.74777C4.03933 6.6339 4.2582 6.47892 4.44556 6.28985L7.6109 3.1245C8.02779 2.72654 8.09783 2.08636 7.7769 1.60765C7.40338 1.09754 6.68706 0.986784 6.17691 1.36031C6.1357 1.3905 6.09652 1.42341 6.05971 1.45883L0.335755 7.18279C-0.111572 7.62962 -0.111966 8.35445 0.334861 8.80177C0.335147 8.80206 0.335469 8.80238 0.335755 8.80267L6.05971 14.5266C6.5074 14.9731 7.23223 14.9721 7.6787 14.5244C7.71383 14.4891 7.74663 14.4516 7.7769 14.4121C8.09783 13.9334 8.02779 13.2933 7.6109 12.8953L4.45128 9.72423C4.28332 9.55608 4.09021 9.4151 3.87888 9.30638L3.53545 9.15183H14.7773C15.3621 9.17355 15.8752 8.76503 15.9851 8.19021C16.0863 7.56612 15.6624 6.97816 15.0383 6.87692Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3061_4801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowLeft2);
export default __webpack_public_path__ + "static/media/ic-arrow-left-2.77842dd004e65d9436164fd1d26a24cc.svg";
export { ForwardRef as ReactComponent };